import z from "zod";
import { FullAlertConfigSchema } from "./EditAlertSchema";

// Schema for individual alert items in the list response
export const AlertsListItemSchema = z.object({
  alertId: z.string(),
  alertName: z.string(),
  alertDescription: z.string(),
  alertFrequency: z.string(),
  createdBy: z.string(),
  updatedBy: z.string(),
  enabledFlag: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  expiredAt: z.string(),
  triggeredCount: z.number(),
});

export const AlertsListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(AlertsListItemSchema),
  count: z.number(),
  group: z.string(),
});

export const AlertStatusResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  alertId: z.string(),
  enabledFlag: z.boolean(),
});

export const AlertUpdateResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  newConfig: FullAlertConfigSchema,
});

export const GetAlertByIdRequestSchema = z.object({
  alertId: z.string().min(1, "Alert ID is required"),
});

export const GetAlertByIdResponseSchema = z.object({
  success: z.boolean(),
  data: FullAlertConfigSchema,
});

export const DeleteAlertRequestSchema = z.object({
  alertId: z.string().min(1, "Alert ID is required"),
});

export const DeleteAlertResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  alertId: z.string(),
});

// Schema for toggle alert status request
export const ToggleAlertStatusRequestSchema = z.object({
  alertId: z.string(),
  enabledFlag: z.boolean(),
});

// Schema for toggle alert status response
export const ToggleAlertStatusResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  alertId: z.string(),
  enabledFlag: z.boolean(),
});

export type ToggleAlertStatusRequestType = z.infer<typeof ToggleAlertStatusRequestSchema>;
export type ToggleAlertStatusResponseType = z.infer<typeof ToggleAlertStatusResponseSchema>;

export type AlertsListItemType = z.infer<typeof AlertsListItemSchema>;
export type AlertsListResponseType = z.infer<typeof AlertsListResponseSchema>;
export type AlertStatusResponseType = z.infer<typeof AlertStatusResponseSchema>;
export type AlertUpdateResponseType = z.infer<typeof AlertUpdateResponseSchema>;
export type GetAlertByIdRequestType = z.infer<typeof GetAlertByIdRequestSchema>;
export type GetAlertByIdResponseType = z.infer<typeof GetAlertByIdResponseSchema>;
export type DeleteAlertRequestType = z.infer<typeof DeleteAlertRequestSchema>;
export type DeleteAlertResponseType = z.infer<typeof DeleteAlertResponseSchema>;
